import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { formatFunctions } from '@/helpers/functions';
import { dataType } from '@/constants/data-type';
import { orderActions } from '@/actions/trading';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP } from '@/configurations';
import { getSafe } from '@/helpers/global';
import '../../assets/styles/components/order/order-journal-detail.scss';
import { settingConfigs } from '@/configurations';
import moment from 'moment';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';

class OrderJournalDetailMobile extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          data: null,
          orderData: null,
          executionData: null,
          isLoading:true,
          auditData: [],
        }
    }

    handleDetailData = () => {
        const {language, order} = this.props;
        const {data} = this.state
        let bs = '';
        const orderType = data.orderType.value || data.orderType;
        let orderTypeText = '-'
        let orderData = [];
        if(orderType !== '-') {
            orderTypeText = language[`order_type_${orderType.toLowerCase()}`]
        }
        if(data.bs){
            bs = data.bs
        } else {
            const isBuy = this.props.isBuy;
            if(isBuy === true){
                bs = 'B'
            } else {
                bs = 'S'
            }
        }

        if(data.marketID === 'FUND'){
            orderData = [
                { label: language.common_order_id, value: data.orderGroupID },
                {
                    label: language.common_order_direction,
                    value: this.getOrderDirection(bs),
                    classStyle: [`order_status_${bs.toLowerCase()}`]
                },
                { label: language.common_market, value: data.marketID },
                { label: language.common_instrument_id, value: data.instrumentID },
                {
                    label: language.common_price,
                    value: data.price ? `${data.currencyID} ${formatFunctions.dataFormat(data.price, dataType.STOP_PRICE)}` : '-'
                },
                { label:language.funds_instrument_name, value: this.mapStockName(data) ?  this.mapStockName(data) : '-' },
                {
                    label: language.common_quantity,
                    value: this.handleQuantityText(data.qty,data.marketID)
                },
                { 
                    label: language.common_filled_quantity_mobile, 
                    value: this.handleQuantityText(data.filledQty,data.marketID)
                },
                {
                    label: language.common_good_till_date,
                    value: data.goodTillDate ? formatFunctions.dataFormat(data.goodTillDate, dataType.SHORT_DATE) : '-',
                },
                { 
                    label: language.common_cancelled_quantity,
                    value: this.handleQuantityText(data.cancelQty,data.marketID)
                },
                { 
                    label: language.common_transaction_time,
                    value: data.inputTime ? formatFunctions.dataFormat(data.inputTime, dataType.LONG_DATE) : '-'
                },
                { 
                    label: language.common_outstanding_quantity_mobile,
                    value: this.handleQuantityText(data.osQty || data.osqty),
                    classStyle: ['order_contains_item_os']
                },
                {
                    label: data.bs === 'B' ? language.common_funds_subscription_F :language.common_funds_redemption_F ,
                    value: data.bs === 'B' ?  `${data.currencyID} ` +  data.feesList.filter(item =>{ return item.feeID == 'FUND.SUB'})[0]?.amount : `${data.currencyID} ` +  data.feesList.filter(item =>{ return item.feeID == 'FUND.REDEM'})[0]?.amount
                },
                {
                    label: language.common_gross_amount,
                    value: data.netAmt ? `${data.currencyID} ${formatFunctions.dataFormat(data.netAmt, dataType.CASH)}` : '-'
                }
            ]
        } else {
            orderData = [
                { label: language.common_order_id, value: data.orderGroupID },
                { label: language.common_order_type, value: orderTypeText },
                {
                    label: language.common_order_direction,
                    value: this.getOrderDirection(bs),
                    classStyle: [`order_status_${bs.toLowerCase()}`]
                },
                { label: language.common_symbol, value: `${data.marketID}.${data.instrumentID}` },
                { label: language.common_name, value: this.mapStockName(data) ?  this.mapStockName(data) : '-' },
                {
                    label: language.common_price,
                    value: data.price ? `${data.currencyID} ${formatFunctions.dataFormat(data.price, dataType.CURRENCY)}` : '-'
                },
                {
                    label: language.common_quantity,
                    value: this.handleQuantityText(data.qty)
                },
                {
                    label: language.common_good_till_date,
                    value: data.goodTillDate ? formatFunctions.dataFormat(data.goodTillDate, dataType.SHORT_DATE) : '-',
                },
                {
                    label: language.common_stop_type,
                    value: getSafe(() => language[`order_stop_price_type_${data.stopOrderType}`], '-')
                },
                {
                    label: language.common_stop_price,
                    value: data.stopPrice ? `${data.currencyID} ${formatFunctions.dataFormat(data.stopPrice, dataType.CURRENCY)}` : '-'
                },
                { 
                    label: language.common_filled_quantity_mobile, 
                    value: this.handleQuantityText(data.filledQty)
                },
                { 
                    label: language.common_cancelled_quantity,
                    value: this.handleQuantityText(data.cancelQty)
                },
                { 
                    label: language.common_transaction_time,
                    value: data.inputTime ? formatFunctions.dataFormat(data.inputTime, dataType.LONG_DATE) : '-'
                },
                { 
                    label: language.common_outstanding_quantity_mobile,
                    value: this.handleQuantityText(data.osQty || data.osqty),
                    classStyle: ['order_contains_item_os']
                },
            ]
        }
        this.setState({
            orderData: orderData,
            isLoading:false
        })
    }

    handleQuantityText(value,id) {
        const { language } = this.props;
        let text = '-';
        if (value !== null) {
            text =  (id === "FUND" ? `${formatFunctions.dataFormat(value, dataType.FUNDS_QUANTITY)} ${language.fund_Unit.format((language.lang === 'en_US' && value > 1) ? 's' : '')}` : `${formatFunctions.dataFormat(value, dataType.NUMBER)} ${language.common_shares.format((language.lang === 'en_US' && value > 1) ? 's' : '')}`)
        }
        return text;
      }

    mapStockName(data){
        const { language } = this.props
        let stockName = '' 
        if(language.title === 'zh_TW' || language.title === 'zh_CN'){
            if(data.instrumentChineseName || data.instrumentChineseShortName){
                stockName = data.instrumentChineseName || data.instrumentChineseShortName
            }else{
                stockName = data.instrumentName || data.instrumentShortName
            }
        }else{
            stockName = data.instrumentName || data.instrumentShortName
        }
        return stockName
    }

    componentDidMount(){
        // this.handleDetailData();
        this.getData();
        if(this.props.closeall){
            this.props.closeAllBox(true)
        }
    }

    getData = () => {
        const { currentTradingAccount, language, order, dateFilter } = this.props
        if (currentTradingAccount.clientID) {
            const params = {
                [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
                [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
                [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
                [PARAMS.ORDER_GROUP_ID]: order.orderGroupID,
                [PARAMS.GET_EXECUTED_DETAILS]: 'Y',
                [PARAMS.GET_AUDIT_DETAIL]: 'Y',
                [PARAMS.LANGUAGE]: language.lang,
            }
            this.props.getOrderDetail(params, res => {
                if (res.status === SERVICES_RESP.STATUS_OK) {
                    if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
                        const data = res.result.orderInfoList.length > 0 ? res.result.orderInfoList[0] : order;
                        this.setState({ 
                            executionData: res.result.executedList,
                            data: data,
                            auditData: res.result.auditList
                        },() => {
                            this.handleDetailData()
                        });
                    }
                }
            })
        }
    }

    getOrderDirection = (bs) => {
        const {language} = this.props
        const {data} = this.state;
        let direction = ''
        if(data.marketID === 'FUND') {
            if(bs === 'B'){
                direction = language.common_funds_subscription
            } else {
                direction = language.common_funds_redemption
            }   
        } else {
            if(bs === 'B'){
                direction = language.common_buy
            } else {
                direction = language.common_sell
            }
        }
        return direction
    }

    getStatusTextColor = (value) => {
        switch (value) {
            case 'REJ': return 'status-refused';
            case 'KLL': return 'status-inactive';
            case 'CAN': return 'status-inactive';
            case 'SPC': return 'status-inactive';
            case 'EXP': return 'status-inactive';
            case 'PEX': return 'status-inactive';
            case 'BIX2': return 'status-inactive';
            case 'PSB': return 'status-ongoing';
            case 'SND': return 'status-ongoing';
            case 'BMS': return 'status-ongoing';
            case 'BSS': return 'status-ongoing';
            case 'CMO': return 'status-ongoing';
            case 'MSD': return 'status-ongoing';
            case 'MXX': return 'status-ongoing';
            case 'STB': return 'status-ongoing';
            case 'SPO': return 'status-ongoing';
            case 'BIX': return 'status-ongoing';
            case 'CPD': return 'status-filled';
            case 'FLL': return 'status-filled';
            case 'FEX': return 'status-filled';
            case 'ALF': return 'status-filled';
            case 'SPF': return 'status-filled';
            case 'PXP': return 'status-filled';
            case 'SPP': return 'status-filled';
            case 'IAV': return 'status-ongoing';
            case 'SOI': return 'status-ongoing';
            case 'NEW': return 'status-ongoing';
            case 'SOR': return 'status-ongoing';
            default: return '';
        }
    }

    render(){
        const {language, order} = this.props
        const {orderData,isLoading,executionData,data,auditData} = this.state;
        return(
            <>
            <LoadingLayer load={isLoading} type={LOADING_TYPE.BIG_IMG} />
            {!isLoading && <div className='order-detail-mobile-container'>
                <div className='detail-status'>
                    <span>
                        {language.order_latest_status}: {language[`order_status_${data.status.toLowerCase()}`]}({data.status})
                    </span>
                </div>
                <div className='detail-container'>
                    {orderData.map(item => 
                        <div className={classnames('detail-container-item')} key={item.label}>
                            <span>{item.label}</span>
                            <span className={classnames('value', getSafe(() => item.classStyle.join(' '), ''))}>{item.value}</span>
                        </div>
                    )}
                </div>
                <div className='detail-execution'>
                    <div className='detail-execution-title'>{language.order_execution_details}</div>
                    {executionData.length > 0 ? <div className='detail-execution-table'>
                        <div className='detail-execution-table-head'>
                            <div style={{width:'50%',textAlign:'left'}}>{language.order_execution_date_time_mobile}</div>
                            <div style={{width:'25%',textAlign:'right'}}>{language.order_execution_quantity_mobile}</div>
                            <div style={{width:'25%',textAlign:'right'}}>{language.order_execution_price_mobile}</div>
                        </div>
                        <div className='detail-execution-table-container'>
                            {executionData.map((item,index) => 
                                <div className='detail-execution-table-container-item' key={index}>
                                    <div style={{width:'50%',textAlign:'left'}}>{item.tradeDate + ' ' + item.tradeTime}</div>
                                    <div style={{width:'25%',textAlign:'right'}}>{formatFunctions.dataFormat(item.qty, dataType.NUMBER)}</div>
                                    <div style={{width:'25%',textAlign:'right'}}>{formatFunctions.dataFormat(item.price, dataType.CURRENCY)}</div>
                                </div>
                            )}
                        </div>
                    </div> : <div className='detail-execution-noData'>{language.common_no_data}</div>}
                </div>
                <div className='detail-audit'>
                    <div className='detail-audit-title'>{language.order_audit}</div>
                    {auditData.length > 0 ? auditData.map((item, index) => 
                        <div className='detail-audit-table' key={index}>
                            <div className='detail-audit-table-head'>
                                <span>
                                    {item.actionTime ? moment(item.actionTime).format(settingConfigs.LONG_DATE) : '-'}
                                </span>
                                <span className={this.getStatusTextColor(item.status)}>
                                    {getSafe(() => language[`order_status_${item.status.toLowerCase()}`])}
                                </span>
                            </div>
                            <div className='detail-audit-table-container'>
                                <div className='container-price'>
                                    <span>{language.common_price}</span>
                                    <span>{item.actionPrice ? formatFunctions.dataFormat(item.actionPrice, dataType.CURRENCY) : '-'}</span>
                                </div>
                                <div className='container-qty'>
                                    <span>{language.common_quantity}</span>
                                    <span>{item.actionQty ? formatFunctions.dataFormat(item.actionQty, dataType.NUMBER) : '-'}</span>
                                </div>
                                <div className='container-remark'>
                                    <span>{language.common_remark}</span>
                                    <span>{item.remark ? auditData.remark : '-'}</span>
                                </div>
                            </div>
                        </div>
                    ) : <div className='detail-audit-noData'>{language.common_no_data}</div>}
                </div>
            </div>}
            </>
        )
    }
}
export default connect(
    state => ({
      language: state.app.language,
      currentTradingAccount: state.trade.currentTradingAccount
    }),
    dispatch => ({
        getOrderDetail: (p, c) => dispatch(orderActions.getOrderDetailAction(p, c))
    })
)(OrderJournalDetailMobile)